module.exports = __webpack_public_path__ + "img/vertical_7_2_3009.af50b335.png";